// extracted by mini-css-extract-plugin
module.exports = {"tabList":"style_tabList__6DkxF","categorySection":"style_categorySection__1gOYp"};